import { Box, CircularProgress } from "@mui/material";

const FullScreenLoading = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      {/* <p>Loading ...</p> */}
      <CircularProgress />
    </Box>
  );
};

export default FullScreenLoading;
